module.exports = __webpack_public_path__ + "static/media/3.47d49beb.png";